'use strict';exports.__esModule = true;var _constants = require('../constants');

var appendLocale = function appendLocale() {var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.language.default;var route = arguments[1];
  var prefix = locale === _constants.language.default ? '' : '/' + locale;
  return prefix + route;
};exports.default =

appendLocale;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/appendLocale.js
// module id = 12
// module chunks = 0